import { BoxArrowUp } from 'react-bootstrap-icons';

interface CartIconProps {
    closefunc: (viewable: boolean) => void;
}

function UIStepBackButton({closefunc}: CartIconProps){
    return (
        /* Need to write code to capture half stars */
        <> 
            <div className="d-inline-block">
                <BoxArrowUp onClick={(e) => closefunc(false)} size={38} />
            </div>
        </>
    )
}

export default UIStepBackButton;